// Stand-by app — sidebar voluta vuota finché non c'è una verticale intermediari attiva.
// Vedi project_frontend_decisions.md rev 3/4 — simmetria di STRUTTURA, non di feature.

export function Sidebar(): JSX.Element {
  return (
    <aside className="flex h-full w-56 shrink-0 flex-col border-r border-border bg-card">
      <div className="flex h-14 items-center px-4 text-sm font-semibold tracking-tight text-foreground">
        ab-platform
      </div>
      <div className="px-4 py-2 text-xs text-muted-foreground">
        Intermediari — stand-by
      </div>
    </aside>
  );
}
